<template>
  <div class="wrap">
    <!-- 头部 -->
    <headTop :toggle="3"></headTop>
    <!-- 中间内容 -->
    <div class="specialistContent">
      <div style="padding: 0.2em 3em 0.8em 3em; box-sizing: border-box">
        <!-- 左侧菜单栏 -->
        <div class="box">
          <div class="specialistContent_left">
            <div class="specialistContent_left_title">企业展馆</div>
            <div
              class="bG"
              v-for="(item, index) in leftMenu1"
              :key="index"
              :class="{ active: toggle == item.name }"
              @click="changeDetail(item)"
            >
              {{ item.name }}
            </div>
          </div>
          <!-- 右侧内容 -->
          <div class="specialistContent_right">
            <div class="specialistContent_right_title">
              <div class="title">{{ toggle }}</div>
            </div>
            <div class="rightContent" v-if="toggle == '产品与服务'">
              <ul class="listBox" v-if="list.length > 0">
                <li
                  v-for="item in list"
                  :key="item.id"
                  @click="goToDetail(item.id)"
                >
                  <img
                    :src="$store.getters.imgUrl + item.logo"
                    alt
                    v-if="item.logo"
                  />
                  <!-- <img src="@/assets/image/equipment/3.png" alt="" v-else> -->
                  <div class="NoLogoBox" v-else>
                    <span>{{ item.name }}</span>
                  </div>
                  <span class="company">{{ item.enterpriseName }}</span>
                  <span class="listBox-title">{{ item.name }}</span>
                  <!-- <span class="info">{{item.content}}</span> -->
                  <div class="buttonZX">详情</div>
                </li>
                <li
                  v-show="list.length % 4 > 0"
                  v-for="item in 4 - (list.length % 4)"
                  :key="item"
                  class="addLi"
                ></li>
              </ul>
              <div style="margin-top: -10px" v-if="list.length > 0">
                <Pagination
                  :name="name"
                  :total="total * 1"
                  @change="changePagination"
                  v-show="toggle == '产品与服务'"
                ></Pagination>
              </div>
            </div>

            <!-- <div v-else>暂无数据</div> -->

            <div
              class="rightInfo"
              v-if="toggle == '单位简介'"
              v-html="mode.introductionContent"
              style="text-indent: 30px; letter-spacing: 1.5px"
            ></div>
            <div v-if="imgBoxList.length > 0">
              <imgBox :list="imgBoxList"></imgBox>
            </div>
            <div
              class="honor-content"
              v-if="honorList.length > 0 && toggle == '单位简介'"
            >
              <div class="title">资质荣誉</div>

              <div class="honor-img-container">
                <div 
                v-for="(img,index) in honorList" :key="index"
                class="honor-img-wrapper">
                  <div class="honor-inner" @click="openDialog(img.img)">
                    <div class="honor-img-inner">
                      <img
                        :src="img.thumbnail"
                        alt
                        class="honor-img"
                      />
                    </div>
                  </div>

                  <div class="honor-title">
                     {{img.name }}
                  </div>
                </div>
            
              </div>
            </div>
            <div
              class="serviceContent"
              v-if="expertList.length > 0 && toggle == '单位简介'"
            >
              <div class="title">专家介绍</div>
              <div
                class="serviceContent_item"
                v-for="item in expertList"
                :key="item.id"
                @click="goToSavant(item.id)"
              >
                <div class="serviceContent_item_left">
                  <div
                    class="imageRound"
                    :style="{
                      'background-image': `url(${
                        $store.getters.imgUrl + item.avatar
                      })`,
                    }"
                  ></div>
                  <!-- <img class="imageRound" :src="$store.getters.imgUrl+item.avatar" alt=""> -->
                  <h6 class="name">{{ item.name }}</h6>
                </div>
                <div class="serviceContent_item_right">
                  <h5>个人简介</h5>
                  <div v-html="item.introduceContent"></div>
                  <div v-html="item.goodContent"></div>
                  <div v-html="item.honorContent"></div>
                </div>
              </div>
            </div>

            <!-- <div class="rightInfo" v-if="toggle== '单位简介'" v-html="mode.honorContent">{{}}</div> -->
          </div>
        </div>
      </div>
         <el-dialog :visible.sync="dialogVisible" @close='closeDialog' style="z-index:999">
                  <img width="100%" height="100%" :src="dialogImageUrl" alt />
                </el-dialog>
      <div class="footer">
        <footCode></footCode>
      </div>
    </div>
  </div>
</template>
<script>
import footCode from "../../components/footCode";
import headTop from "../../components/HeadTop";
import Pagination from "@/components/pagination";
import imgBox from "../../components/imgBoxAndDialog";
export default {
  name: "enterpriseDetail",
  components: {
    footCode,
    headTop,
    Pagination,
    imgBox,
  },
  data() {
    return {
      leftMenu1: [
        { name: "单位简介", id: 1 },
        { name: "产品与服务", id: 2 },
      ],
      toggle: "单位简介",
      list: [],
      officeId: "",
      total: "",
      name: "产品与服务",
      mode: {},
      sendAxios: {
        page: 1,
        limit: 12,
        enterpriseId: "",
      },
      expertList: [],
      imgBoxList: [],
      honorList: [],
      dialogVisible:false,
      dialogImageUrl:'',
    };
  },
  activated() {
    this.sendAxios.enterpriseId = this.$route.query.id;
    this.getDetail();
    this.getList();
  },
  beforeRouteLeave(to, from, next) {
    this.toggle = "单位简介";
    next();
  },

  methods: {
    changePagination(current) {
      // 第几页
      this.sendAxios.page = current;
      this.getList();
    },
    getDetail() {
      this.ajaxUtil({
        method: "get",
        url:
          this.$store.state.axiosUrl +
          `/api/home/v3/getHallInfoById?enterpriseId=${this.sendAxios.enterpriseId}`,
        // params: {},
      }).then((res) => {
        this.mode = res.data.hall;
        // console.log("this.mode ",this.mode )
        this.expertList = res.data.expertList;
        let a = this.mode.honorContent
          .split("img")
          .map((item) => {
            if (item.includes("src")) return item.split("alt")[0].slice(6, -2);
          })
          .splice(1);
        this.imgBoxList = a;
        this.honorList = res.data.honorList;
        console.log(a);
      });
    },
    getList() {
      this.ajaxUtil({
        method: "get",
        url: this.$store.state.axiosUrl + `/api/home/v2/product/page`,
        params: this.sendAxios,
      }).then((res) => {
        this.list = res.data;
        this.total = res.count;
      });
    },
    changeDetail(item) {
      this.toggle = item.name;
      this.officeId = item.id;
      //   this.getDetail();
    },
    goToDetail(id) {
      this.$router.push({
        path: "/case/caseDetail",
        query: {
          id: id,
          index: 3,
        },
      });
    },
    goToConsultation(pid) {
      if (!pid) pid = 0;
      let token = sessionStorage.getItem("token");
      if (!token) {
        this.$message.error("请先登录");
        return false;
      } else {
        this.$store.commit("changechatShow", true);
        this.$store.commit("changePid", pid);
      }
    },
    openDialog(url){
        this.dialogImageUrl = url;
        this.dialogVisible = true;
    },
    //关闭弹框的事件
    closeDialog(){
      setTimeout(()=>{
        this.dialogImageUrl = "";//清空数据
      },300) 
    },
  },
};
</script>
<style scoped lang="less">
// @import url('~@/assets/css/index.less');
.wrap {
  display: flex;
  flex-direction: column;
  min-width: 12.8em;
}
// 公共标题样式
.title {
  color: #2579bf;
  font-size: 16px;
  padding-bottom: 5px;
  border-bottom: 4px solid #2579bf;
  display: inline-block;
}
.swiper_box {
  display: none !important;
}
.specialistContent {
  display: flex;
  flex-direction: column;
  flex: 1;
  // overflow-y: auto;
  width: 100%;
  justify-content: space-between;
  // padding: 0.2em 3em;
  .specialistContent_left {
    font-size: 0.17em;
    color: #333;
    div {
      height: 2.5em;
      text-align: center;
      background-color: #d6f0f6;
      margin-top: 0.08em;
      cursor: pointer;
      font-size: 0.85em;
      width: 240px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .specialistContent_left_title {
      background: radial-gradient(circle, #3cc9e4 0%, #2579bf 100%);
      color: #fff;
      padding: 0.6em;
      //   width: 15em;
      font-size: 1em;
    }
    .bG:hover{
      color: #2579bf;
      background-color: #fff;
    }
    .active {
      color: #2579bf;
      background-color: #fff;
      border-left: 0.5em solid #2579bf;
    }
  }
  .specialistContent_right {
    color: #333;
    margin-left: 2em;
    margin-top: 0.1em;
    font-size: 0.18em;
    flex: 1;
    overflow: hidden;
    // width: 100%;
    .specialistContent_right_title {
      font-size: 0.2em;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 1em;
      border-bottom: 1px solid #e5e5e5;
      div {
        padding-bottom: 1em;
      }
    }
    //   列表
    .listBox {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      li {
        border: 1px solid #eee;
        display: flex;
        flex-direction: column;
        // height: 225px;
        cursor: pointer;
        position: relative;
        width: 22%;
        padding-bottom: 0em;
        margin-top: 20px;
        // height: 13em;

        .listBox-title {
          width: 100%;
          height: 54px;
          line-height: 23px;
          color: #2579bf;
          font-size: 0.8em !important;
          font-weight: 600;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        img {
          height: 122px;
          width: 100%;
        }
        span {
          font-size: 0.28em;
          padding: 5px 10px;
        }
        .company {
          position: absolute;
          top: 95px;
          left: 0;
          width: 100%;
          font-size: 0.8em;
          white-space: nowrap;
          background-color: rgba(0, 0, 0, 0.5);
          color: #fff;
          text-overflow: ellipsis;
          overflow: hidden;
          text-align: center;
        }
        .info {
          padding: 5px 10px;
          padding-bottom: 60px;
          overflow: hidden;
          font-size: 0.15em;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          color: #555;
        }
      }
    }
  }
  .honor-content {
    width: 100%;
    padding-top: 2em;
    .honor-img-container {
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 30%);
      grid-column-gap: 13px;
      grid-row-gap: 13px;
      margin-top: 20px;
      .honor-img-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-content: center;
        .honor-inner {
          width: 100%;
          // width: 310px;
          height: 100%;
          max-height: 181px;
          background-color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border: 1px solid rgb(165, 165, 165);
          .honor-img-inner {
            width: 90%;
            height: 90%;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            .honor-img {
              width: 100%;
              height: 100%;
              max-height: 181px;
              min-height: 64px;
              object-fit: contain;
            }
          }
        }
        .honor-title {
          width: 100%;
          text-align: center;
          vertical-align: middle;
          background-color: rgb(84, 130, 53);
          color: #fff;
          margin-top: 10px;
          padding: 5px;
          min-height: 37px;
          max-height: 37px;
          font-size: 18px;
          line-height: 27px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
.footer {
  width: 100%;
  // margin-top: 0.2em;
}
.titlePosition {
  font-size: 0.15em;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  color: #666;
}
.box {
  display: flex;
  justify-content: space-between;
  height: 100%;
  overflow: hidden;
}
.addLi {
  border: none !important;
}
.NoLogoBox {
  background-image: url("~@/assets/image/equipment/3.png");
  height: 122px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-family: hzgb;
  align-items: center;
  text-align: -webkit-center;

  span {
    margin-top: -20px;
    font-size: 13px !important;
    font-weight: 600;
    letter-spacing: 3px;
  }
}
.buttonZX {
  text-align: center;
  padding: 7px;
  background: linear-gradient(-90deg, #25ccbd 0%, #30a8da 100%);
  color: #fff;
  margin-top: 10px;
  font-size: 15px;
  cursor: pointer;
  font-weight: 600;
  // position: absolute;
  // bottom: 0;
  // left: 0;
  // width: 100%;
}
/deep/.rightInfo {
  font-size: 1em !important;
  margin-top: 20px;
  img {
    max-width: 100%;
  }
}
.rightContent {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.serviceContent_item {
  cursor: pointer;
}
.serviceContent {
  padding-top: 2em;
  padding-left: 0em;
  &_item {
    border-bottom: 1px solid #e5e5e5;
    padding: 0.3rem 0;
    display: flex;
    &_left {
      margin: 0 0.2rem 0 0;
      .image {
        width: 2.4rem;
        // height: 1.3rem;
        margin: 0 0 0.15rem;
        border: 1px solid #e5e5e5;
      }
      .imageRound {
        width: 1.36rem;
        height: 1.36rem;
        margin: 0 0 0.15rem;
        border-radius: 100%;
        border: 1px solid #e5e5e5;
        background-size: cover;
      }
      h6 {
        color: #2579bf;
        font-size: 0.9em;
        text-align: center;
        &.name {
          color: #666;
        }
      }
    }
    &_right {
      font-size: 1em;
      color: #333;
      h5 {
        font-size: 1em;
        margin: 0 0 0.4em;
      }
      /deep/p {
        text-indent: 30px;
        line-height: 22px;
      }
    }
  }
  h4 {
    margin-bottom: 0.5em;
    font-size: 0.9em;
  }
  .content {
    display: inline-block;
    text-indent: 40px;
    line-height: 1.5em;
    font-size: 0.9em;
  }
  span {
    font-size: 0.9em;
  }
  //头像
  .serviceContentList {
    display: flex;
    flex-direction: column;

    .serviceContentListItem {
      display: flex;
      // align-items: center;
      margin-top: 20px;
      .left {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 30px;
      }
      .right {
        display: flex;
        flex-direction: column;
        span {
          text-indent: 30px;
          margin-top: 5px;
        }
      }
    }
    img {
      width: 4em;
      height: 4em;
      margin-bottom: 0.5em;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/enterprise/enterpriseDetail.vue